"use client";

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";
import { ToastItem } from "./ToastItem";
import { toastStore } from "./toastStore";
export const ToastContainer = () => {
  const $ = _c(4);
  const toasts = useSyncExternalStore(toastStore.subscribe, toastStore.getSnapshot, toastStore.getServerSnapshot);
  let t0;
  if ($[0] !== toasts) {
    t0 = toasts.map(_temp);
    $[0] = toasts;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div id="toast-container" aria-live="polite" className="fixed right-3 top-3 z-[999999]">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(toast) {
  return <ToastItem key={toast.id} toastId={toast.id} kind={toast.kind} message={toast.message} />;
}